import { useLayoutEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";

import {
  areRouteColorIdMapsEqual,
  routeColorIdMatchesAtom,
  routeColorIdMatchesResolvedSelector,
} from "@ryde/shared";

/**

 * Persists `routeColorIdMatchesResolvedSelector` into the atom for sticky reuse on the next build.

 * Palette is built only in the selector — no second `buildRouteColorIdMatchesMap` here.

 */

export const useMapColorsService = (): void => {
  const setRideColorMatches = useSetRecoilState(routeColorIdMatchesAtom);

  const resolvedMap = useRecoilValue(routeColorIdMatchesResolvedSelector);

  useLayoutEffect(() => {
    setRideColorMatches(prevMap =>
      areRouteColorIdMapsEqual(prevMap, resolvedMap) ? prevMap : resolvedMap,
    );
  }, [resolvedMap, setRideColorMatches]);
};
